package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class FeedItemDto(
    val id: String,
    val authorType: String,
    val authorId: String,
    val authorName: String,
    val authorAvatarUrl: String? = null,
    val content: String,
    val city: String? = null,
    val cardImageUrl: String? = null,
    val cardAssetsBasePath: String? = null,
    val cardTextColor: String? = null,
    val cardAvatarUrl: String? = null,
    val layout: Int = 1,
    val images: List<FeedImageDto>,
    val likesCount: Int,
    val isLikedByMe: Boolean,
    val commentsCount: Int = 0,
    val createdAt: String
)

@Serializable
data class FeedImageDto(
    val id: String,
    val imageUrl: String,
    val sortOrder: Int
)

@Serializable
data class FeedPageDto(
    val items: List<FeedItemDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int
)

@Serializable
data class FeedStoryItemDto(
    val id: String,
    val imageUrl: String,
    val createdAt: String,
    val isSeen: Boolean,
    val likesCount: Long = 0,
    val isLikedByMe: Boolean = false,
    val viewsCount: Long = 0,
)

@Serializable
data class FeedStoryAuthorGroupPageDto(
    val items: List<FeedStoryAuthorGroupDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int,
)

@Serializable
data class FeedStoryAuthorGroupDto(
    val authorId: String,
    val authorName: String,
    val authorAvatarUrl: String? = null,
    val cardImageUrl: String? = null,
    val cardAssetsBasePath: String? = null,
    val cardTextColor: String? = null,
    val cardAvatarUrl: String? = null,
    val stories: List<FeedStoryItemDto>,
    val allSeen: Boolean,
)
